import { TenantContext, TenantContextProvider } from './types';
import Cookies from 'universal-cookie';
import jwtDecode from 'jwt-decode';

// 租户上下文缓存
const tenantCtx = reactive<TenantContext>({
  tenantId: '',
  userName: '',
  userId: 0,
  mask: 0
});

function resetTenantCtx() {
  tenantCtx.tenantId = '';
  tenantCtx.userId = 0;
  tenantCtx.userName = '';
  tenantCtx.mask = 0;
}

let prevCookies = '';

// 读取租户上下文
function getTenantContext(): TenantContext {
  const curCookies = document.cookie;
  // cookie变了主不能使用cache
  if (tenantCtx.tenantId && curCookies == prevCookies) {
    return tenantCtx;
  }

  const cookies = new Cookies(curCookies);
  const token = cookies.get('X-HC-TOKEN');
  if (!token) {
    resetTenantCtx();
    return tenantCtx;
  }

  try {
    const payload = jwtDecode<any>(token);
    const {
      sid: tenantId = '',
      un: userName = '',
      ud: userId = 0,
      mk: mask = 0
    } = payload ?? {};

    if (!tenantId) {
      resetTenantCtx();
      return tenantCtx;
    }

    tenantCtx.tenantId = tenantId;
    tenantCtx.userId = Number(userId);
    tenantCtx.userName = userName;
    tenantCtx.mask = Number(mask);

    // 记录cookie
    prevCookies = curCookies;

    return tenantCtx;
  } catch (e) {
    resetTenantCtx();
    return tenantCtx;
  }
}

// 清除缓存
function clearTenantContextCache() {
  resetTenantCtx();
}

export default {
  get: getTenantContext,
  clear: clearTenantContextCache
} as TenantContextProvider;
